import 'whatwg-fetch';

export default class Aprentis {
   constructor(domain) {
      this.domain = domain;
   }

   login (email, password){
      var base64val = window.btoa(email + ":" + password);
      var reqHeaders = {
         'Content-Type': 'application/json',
         'Authorization': `Basic ${base64val}`
      };

      return fetch(this.domain + '/authenticate/json/v2', {
            method: 'post',
            headers: reqHeaders,
            body: '',
            mode: 'cors'
         })
         .then(checkHttpStatus)
         .then(parseJSON)
         .catch(function(error) {
            if (!!console && !!console.log){
               console.log('There has been a problem with your fetch operation: ' + error.message);
            }
            // ADD THIS THROW error
            throw error;
         });
   }

   fetchData (token, dataKey, view = null){
      var reqHeaders = {
         'Content-Type': 'application/json',
         'Token': `${token}`,
         'Remember': 'true'
      };
      if (view && view !== ''){
         Object.assign(reqHeaders, {'View': view});
      }

      return fetch(this.domain + `/${dataKey}/json/v2`, {
         method: 'get',
         headers: reqHeaders,
         credentials: 'omit',
         mode: 'cors'
         })
         .then(checkHttpStatus)
         .then(parseJSON)
         .catch(function(error) {
            if (!!console && !!console.log){
               console.log('There has been a problem with your fetch operation: ' + error.message);
            }
            // ADD THIS THROW error
            throw error;
         });
   }

   pressButton (token, contextKey, buttonId){
      let reqHeaders = {
         //'Content-Type': 'application/json',
         'Token': `${token}`,
         'Remember': 'true',
         'Button': `${buttonId}`
      };

      const payload = {};
      let reqData = JSON.stringify( payload );

      return fetch(this.domain + `/${contextKey}/json/v2`, {
         method: 'post',
         headers: reqHeaders,
         body: reqData,
         credentials: 'omit',
         mode: 'cors'
      })
         .then(checkHttpStatus)
         .then(parseJSON)
         .catch(function(error) {
            if (!!console && !!console.log){
               console.log('There has been a problem with your press button operation: ' + error.message);
            }
            // ADD THIS THROW error
            throw error;
         });
   }

   search (token, contextKey, searchPhrase){
      const reqHeaders = {
         'Content-Type': 'application/json',
         'Token': `${token}`,
         'Remember': 'true'
      };

      const payload = {
         query: searchPhrase
      };
      let reqData = JSON.stringify( payload );

      return fetch(this.domain + `/${contextKey}/search/json/v2/`, {
         method: 'post',
         headers: reqHeaders,
         body: reqData,
         credentials: 'omit',
         mode: 'cors'
      })
         .then(checkHttpStatus)
         .then(parseJSON)
         .catch(function(error) {
            if (!!console && !!console.log){
               console.log('There has been a problem with your search operation: ' + error.message);
            }
            // ADD THIS THROW error
            throw error;
         });
   }
}

function checkHttpStatus(response) {
   if (response.status >= 200 && response.status < 300) {
      return response
   } else {
      var error = new Error(response.statusText);
      error.response = response;
      throw error;
   }
}

function parseJSON(response) {
   return response.json();
}



// WEBPACK FOOTER //
// ./src/api/Aprentis.js